import isString from 'lodash/isString';

export default class FormErrors {
  /**
   * FormErrors constructor.
   * @param {*} errors
   */
  constructor(errors = null) {
    this.errors = errors;
    this.message = null;
  }

  /**
   * Clear errors.
   */
  clear() {
    this.errors = null;
    this.message = null;
  }

  /**
   * Determine if field has error.
   * @param {string|string[]} name
   * @returns {boolean}
   */
  has(name) {
    if (!this.errors) {
      return false;
    }

    if (Array.isArray(name)) {
      for (const entry of name) {
        if (this.errors.hasOwnProperty(entry)) {
          return true;
        }
      }

      return false;
    }

    return this.errors.hasOwnProperty(name);
  }

  /**
   * Get field errors.
   * @param {string|string[]} name
   * @returns {Array|null}
   */
  get(name) {
    if (!this.errors) {
      return null;
    }

    if (Array.isArray(name)) {
      let errors = [];

      for (const entry of name) {
        if (!this.errors.hasOwnProperty(entry)) {
          continue;
        }

        errors = errors.concat(this.errors[entry]);
      }

      return errors.length > 0 ? errors : null;
    }

    return this.errors[name];
  }

  /**
   * Set errors.
   * @param {*} errors
   */
  setErrors(errors) {
    this.errors = errors;
  }

  /**
   * Set error message.
   * @param {string|null} message
   */
  setMessage(message) {
    this.message = message;
  }

  /**
   * Update errors from response.
   * @param {AxiosResponse} error
   */
  updateFromError(error) {
    if (isString(error) || !error || typeof error.response !== 'object') {
      return;
    }

    this.clear();

    if (!error?.response?.status === 422 || !error?.response?.data?.error?.errors) {
      return;
    }

    this.setErrors(error.response.data.error.errors);
  }
}
